import React from 'react';
import { useController } from 'react-hook-form';
import RadioButton from './RadioButton';

type RadioButtonType = React.ComponentProps<typeof RadioButton>;

type ControlledRadioButtonProps = Omit<
  RadioButtonType,
  'onRadioButtonClick'
> & {
  name: string;
  value?: string | undefined;
  onPostChange?: () => void;
};

const ControlledRadioButton: React.FC<ControlledRadioButtonProps> = props => {
  const { name, value, onPostChange = () => {} } = props;

  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    defaultValue: value,
  });

  const handleChange = (name: string, value: string) => {
    field.onChange(value);
    onPostChange();
  };

  return (
    <RadioButton
      {...props}
      {...field}
      onRadioButtonClick={handleChange}
      errorMsg={error?.message}
    />
  );
};

export default ControlledRadioButton;
